export default {
  possibleTypes: {
    AbstractBrand: ['Brand', 'Exhibitor', 'Producer'],
    Item: [
      'Brand',
      'BrandContact',
      'BrandDistributor',
      'CompanyProfile',
      'SingleRegistration',
      'RegisteredProduct',
      'Event',
      'Exhibitor',
      'Producer',
      'CollectionList',
      'RegisteredBrand',
      'BrandProfile',
      'ProductUsedIn',
      'ProductVersionDetails',
      'UserWorkspace',
      'RegistrationProfile',
      'DataImport',
      'DataImportSourceRow',
      'Group',
      'GroupMembership',
      'ProductList',
      'ShareList',
      'ELabel',
      'ValidValues',
      'ELabelFoodBusinessOperator',
      'ELabelForm',
      'Workspace',
      'Beer',
      'Cider',
      'Company',
      'EventGroup',
      'GroupedRegistration',
      'LiveInfoSheet',
      'Spirit',
      'UploadedFile',
      'Wine',
    ],
    Field: ['CustomField', 'ChangedField'],
    FieldValue: [
      'ChangeoverFieldValue',
      'DateFieldValue',
      'FloatFieldValue',
      'ImageFieldValue',
      'IntFieldValue',
      'MultiSelectFieldValue',
      'SelectFieldValue',
      'TextFieldValue',
      'YesNoFieldValue',
    ],
    Connection: [
      'BrandDistributorConnection',
      'BrandDistributorGroupConnection',
      'AttachedNodeConnection',
      'ProducerConnection',
      'ExhibitorConnection',
      'RegisteredProductConnection',
      'RegisteredProductGroupConnection',
      'CollectionListConnection',
      'RegisteredBrandConnection',
      'ProductUsedInConnection',
      'ProductUsedInGroupConnection',
      'DataImportSourceRowConnection',
      'DataImportConnection',
      'EventConnection',
      'GroupMembershipConnection',
      'GroupConnection',
      'ProductListConnection',
      'ShareListConnection',
      'EventGroupConnection',
    ],
    Edge: [
      'BrandDistributorEdge',
      'RegisteredProductEdge',
      'ProducerEdge',
      'ExhibitorEdge',
      'CollectionListEdge',
      'RegisteredBrandEdge',
      'ProductUsedInEdge',
      'SingleRegistrationEdge',
      'DataImportSourceRowEdge',
      'DataImportEdge',
      'EventEdge',
      'GroupMembershipEdge',
      'GroupEdge',
      'ProductListEdge',
      'ShareListEdge',
      'EventGroupEdge',
      'GroupedRegistrationEdge',
    ],
    File: ['LiveInfoSheet', 'UploadedFile'],
    CloudinaryResource: ['CloudinaryAsset'],
    Node: [
      'CompanyProfile',
      'UserProfile',
      'BrandProfile',
      'RegistrationProfile',
      'WorkspaceUser',
    ],
    Profile: [
      'Brand',
      'CompanyProfile',
      'Exhibitor',
      'Producer',
      'BrandProfile',
      'RegistrationProfile',
    ],
    Collection: ['Event', 'Group', 'ProductList', 'ShareList', 'EventGroup'],
    RegistrationConnection: [
      'SingleRegistrationConnection',
      'MixedRegistrationConnection',
      'GroupedRegistrationConnection',
    ],
    RegistrationEdge: ['SingleRegistrationEdge', 'GroupedRegistrationEdge'],
    Registration: ['SingleRegistration', 'GroupedRegistration'],
    Activity: [
      'ProductAddToCollectionActivity',
      'ProductChangeActivity',
      'ProductRemoveFromCollectionActivity',
      'RegistrationAddedActivity',
      'RegistrationChangeByOrganizerActivity',
      'RegistrationCommunicationActivity',
      'RegistrationStartedActivity',
    ],
    HistoryEntry: [
      'FieldChangeHistoryEntry',
      'FieldSetHistoryEntry',
      'FieldUnknownHistoryEntry',
      'FieldUnsetHistoryEntry',
      'ProductAddToCollectionHistoryEntry',
      'ProductChangeHistoryEntry',
      'ProductRemoveFromCollectionHistoryEntry',
    ],
    Message: ['RegistrationMessage'],
    FormField: [
      'IntegerField',
      'MultiSelectField',
      'NumberField',
      'SelectField',
      'TextField',
    ],
    Form: [
      'RegisteredProductForm',
      'RegisteredBrandForm',
      'RegistrationProfileForm',
    ],
    MediaAsset: ['ProductInfoSheet', 'RegistrationInfoSheet', 'QRCode'],
    Product: ['Beer', 'Cider', 'Spirit', 'Wine'],
    List: ['Event', 'ProductList', 'ShareList'],
    AbstractBrandConnection: [
      'ProducerConnection',
      'ExhibitorConnection',
      'BrandConnection',
    ],
    AbstractBrandEdge: ['ProducerEdge', 'ExhibitorEdge'],
    CollectionListItem: ['CollectionListHeading', 'RegisteredProduct'],
    ProductAward: ['BeerAward', 'CiderAward', 'SpiritAward', 'WineAward'],
    RegistrationGroupConnection: [
      'SingleRegistrationGroupConnection',
      'MixedRegistrationGroupConnection',
      'GroupedRegistrationGroupConnection',
    ],
    CatalogSection: [
      'RegistrationCatalogSection',
      'UploadedFileCatalogSection',
    ],
    DataImportAffectedObject: ['Exhibitor'],
    DataImportSource: ['DataImportSourceTabular'],
    ELabelBase: ['ELabel', 'ELabelForm'],
    ELabelFieldValue: [
      'ELabelLocalizedTextFieldValue',
      'ELabelSystemFieldValue',
    ],
    MutationResponse: [
      'AddBrandsToGroupResponse',
      'AddCompaniesRegistrationResponse',
      'AddCompanyRegistrationResponse',
      'AddExternalAssetResponse',
      'UpdatePartnerResponse',
      'AddProductsToProductListResponse',
      'AddProductsToRegistrationResponse',
      'CreateProductListResponse',
      'AddUserToWorkspaceResponse',
      'ArchiveMultipleProductsResponse',
      'ArchiveProductResponse',
      'AttachFileResponse',
      'MeetingResponse',
      'CreateDataFileJobResponse',
      'CreateELabelResponse',
      'ELabelJobExportResponse',
      'CreateGroupResponse',
      'CreateImagesDownloadResponse',
      'CreateInfoSheetsJobResponse',
      'createNewVintageResponse',
      'EditContactResponse',
      'CreateNotificationContactsResponse',
      'CreateProductListJobResponse',
      'CreateQrCodeResponse',
      'CreateQrCodeDownloadJobResponse',
      'CreateStripeCheckoutSessionResponse',
      'UpdateDataImportResponse',
      'deleteInfoSheetConfigurationResponse',
      'DeleteMultipleProductsResponse',
      'DeleteProductResponse',
      'DetachFileResponse',
      'DiscardELabelDraftChangesResponse',
      'DuplicateProductResponse',
      'EditAssetResponse',
      'FinalizeAliasImportResponse',
      'FinalizeProductCreationImportResponse',
      'FinalizeProductDataImportResponse',
      'FinalizeProductExternalIdImportResponse',
      'FinalizeProductInternalIdImportResponse',
      'FinalizeProductListImportResponse',
      'finalizeProductMasterListImportResponse',
      'finalizeProductMasterListSyncResponse',
      'InviteCompanyResponse',
      'MarkRegistrationsAsResponse',
      'PublishELabelResponse',
      'PublishVersionResponse',
      'RemoveBrandFromGroupResponse',
      'RemoveCompanyRegistrationResponse',
      'RemoveELabelResponse',
      'RemoveContactResponse',
      'RemoveProductListResponse',
      'RemoveProductsFromRegistrationResponse',
      'RemoveRegistrationsResponse',
      'RequestAccessToWorkspaceResponse',
      'RequestChatResponse',
      'RequestMeetingResponse',
      'saveInfoSheetConfigurationResponse',
      'SaveMaximumProductsResponse',
      'BulkSaveProductDataResponse',
      'SaveProductDataResponse',
      'SaveStandsResponse',
      'SendContactRequestResponse',
      'sendMessageResponse',
      'SendProductListResponse',
      'sendSampleRequestResponse',
      'SetBrandsActiveInGroupResponse',
      'SetBrandsInactiveInGroupResponse',
      'SetRegisteredProductCustomFieldResponse',
      'SetRegistrationCustomFieldResponse',
      'SetStatusMultipleProductsResponse',
      'ShareProductListResponse',
      'ShareProductListByLinkResponse',
      'ShareProductsResponse',
      'ShareProductsByLinkResponse',
      'ShareShareListResponse',
      'SkipRegistrationResponse',
      'StartRegistrationResponse',
      'ToggleNotificationContactLockResponse',
      'UpdateELabelResponse',
      'SiteUserProfileResponse',
      'UploadDataImportFileResponse',
      'UploadFileResponse',
      'UploadFilesResponse',
      'ValidateVatIdResponse',
      'RemoveFromListResponse',
    ],
    ExtendedProduct: ['Beer', 'Cider', 'Spirit', 'Wine'],
    FieldChange: [
      'ChangeFieldChange',
      'SetFieldChange',
      'UnknownFieldChange',
      'UnsetFieldChange',
    ],
    FieldHistoryEntry: [
      'FieldChangeHistoryEntry',
      'FieldSetHistoryEntry',
      'FieldUnknownHistoryEntry',
      'FieldUnsetHistoryEntry',
    ],
    ProductActivity: [
      'ProductAddToCollectionActivity',
      'ProductChangeActivity',
      'ProductRemoveFromCollectionActivity',
    ],
    RegistrationActivity: [
      'ProductAddToCollectionActivity',
      'ProductRemoveFromCollectionActivity',
      'RegistrationAddedActivity',
      'RegistrationChangeByOrganizerActivity',
      'RegistrationCommunicationActivity',
      'RegistrationMessage',
      'RegistrationStartedActivity',
    ],
    ProductHistoryEntry: [
      'ProductAddToCollectionHistoryEntry',
      'ProductChangeHistoryEntry',
      'ProductRemoveFromCollectionHistoryEntry',
    ],
  },
};
